export const breakpoints = {
  values: {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1366,
    xl: 1920,
  },
} as const;
